module.exports = __webpack_public_path__ + "static/mom-b02ca01e609590f29ef3f64c909751c9.jpg";